import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=063b2e5a&scoped=true&"
import script from "./FooterView.vue?vue&type=script&lang=js&"
export * from "./FooterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b2e5a",
  null
  
)

export default component.exports